// BA WP-1a: auth answers GET /platform/feature-flags?withSeedStatus=true with
// { flags, missingSeededKeys }; an auth that predates it answers the plain
// array. Pure (no env access), so the page and its tests share it.
export interface FlagListResult<F> {
  flags: F[];
  /** Seeded platform flags the table doesn't have: the seed didn't run, or a row was removed. */
  missingSeededKeys: string[];
}

export function normalizeFlagList<F>(body: unknown): FlagListResult<F> {
  if (Array.isArray(body)) return { flags: body as F[], missingSeededKeys: [] };
  const b = body as { flags?: unknown; missingSeededKeys?: unknown } | null;
  return {
    flags: Array.isArray(b?.flags) ? (b!.flags as F[]) : [],
    missingSeededKeys: Array.isArray(b?.missingSeededKeys) ? (b!.missingSeededKeys as string[]) : [],
  };
}
